// extracted by mini-css-extract-plugin
export default {"header":"x5X66QBU73JX9plVygb1","title":"ZQACevLfsb7A62l_ncrB","btn-wide":"jazMN9wOgmz2r3QLoY20","body":"NQIsbWDrZiK_mcyMkyC8"};